import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const bbs = {
  // 获取话题列表
  getTopics: payload => {
    return api.get(proxyApi + '/v3/bbs/topics', payload)
  },
  // 获取话题详情
  getTopicDetail: id => {
    return api.get(proxyApi + `/v3/bbs/topics/${id}`)
  },
  // 获取首页动态列表
  getRecommendNews: payload => {
    return api.get(proxyApi + '/v3/bbs/news/recommend_news', payload)
  },
  // 获取动态详情
  getArticleDetail: id => {
    return api.get(proxyApi + `/v3/bbs/news/${id}`)
  },
  // 发布动态
  setArticle: params => {
    return api.post(proxyApi + '/v3/bbs/news', params)
  },
  // 获取动态一级评论
  getArticleComment: (id, payload) => {
    return api.get(proxyApi + `/v3/bbs/news/${id}/comments`, payload)
  },
  // 话题聚合页热门列表
  getTopicHotArticles: (id, payload) => {
    return api.get(proxyApi + `/v3/bbs/topics/${id}/hot_news`, payload)
  },
  // 话题聚合页动态列表
  getTopicMeArticles: (id, payload) => {
    return api.get(proxyApi + `/v3/bbs/topics/${id}/news`, payload)
  },
  // 动态收藏/取消收藏
  updateArticleCollect: (id, payload) => {
    return api.put(proxyApi + `/v3/bbs/news/${id}/collect_status`, payload)
  },
  // 动态点赞/取消点赞
  updateArticleLike: (id, payload) => {
    return api.put(proxyApi + `/v3/bbs/news/${id}/like_status`, payload)
  },
  // 评论点赞/取消点赞
  updateCommentLike: (news_id, comment_id, payload) => {
    return api.put(proxyApi + `/v3/bbs/news/${news_id}/comments/${comment_id}/like_status`, payload)
  },
  // 查看全部评论
  getAllComment: (news_id, comment_id, payload) => {
    return api.get(proxyApi + `/v3/bbs/news/${news_id}/comments/${comment_id}`, payload)
  },
  // 删除动态
  deleteArticle: id => {
    return api.delete(proxyApi + `/v3/bbs/news/${id}`)
  },
  // 创建一级评论
  createComment: (id, payload) => {
    return api.post(proxyApi + `/v3/bbs/news/${id}/comments`, payload)
  },
  // 回复评论
  replyComment: (news_id, comment_id, payload) => {
    return api.post(proxyApi + `/v3/bbs/news/${news_id}/comments/${comment_id}/reply_comments`, payload)
  },
  // 消息数量
  getNoticeCount: () => {
    return api.get(proxyApi + `/v3/bbs/my_notice/unviewed_count`)
  },
  // 搜索动态
  searchNews: payload => {
    return api.get(proxyApi + `/v3/bbs/news/search_news`, payload)
  },
  // 删除评论
  deleteComment: (news_id, comment_id) => {
    return api.delete(proxyApi + `/v3/bbs/news/${news_id}/comments/${comment_id}`)
  },
  shareArticle: (news_id, payload) => {
    return api.put(proxyApi + `/v3/bbs/news/${news_id}/share_status`, payload)
  },
  //创建投票
  createVote: (params) => {
    return api.post(proxyApi + `/v3/bbs/votes`, params)
  },
  //删除删除
  deleteVote: vote_id => {
    return api.delete(proxyApi + `/v3/bbs/votes/${vote_id}`)
  },
  //编辑投票
  updateVote: (vote_id, data) => {
    return api.put(proxyApi + `/v3/bbs/votes/${vote_id}`, data)
  },
  //进行投票
  onVote: (news_id, vote_id, data) => {
    return api.post(proxyApi + `/v3/bbs/news/${news_id}/votes/${vote_id}`, data)
  },
  //进行投票
  pullCount: () => {
    return api.post(proxyApi + `/v3/bbs/statistics/pull_count`)
  },
  //进行投票
  getLikeRecommend: (payload) => {
    return api.get(proxyApi + `/v3/bbs/news/like_recommend`, payload)
  }
}

export default bbs
